import React from 'react';

import { PrimaryButton } from '@components/Button/variants';

interface StepWelcomeProps {
  isProSubscriber: boolean;
  nextStep: () => void;
}

const StepWelcome = ({ nextStep, isProSubscriber }: StepWelcomeProps) => (
  <div className="onboarding-content center">
    <div>
      <h2 className="onboarding-heading large">
        Welcome to <br />
        The&nbsp;Information
        {isProSubscriber && <span className="text-primary-magenta"> Pro</span>}
      </h2>
      <p className="mt2 mb3">
        We&rsquo;re the leading publication high-powered tech executives and founders read daily.
      </p>
      <PrimaryButton as="button" onClick={nextStep} size="small" fullWidth>
        Get started
      </PrimaryButton>
    </div>
  </div>
);

export default StepWelcome;
